import { FC } from 'react';
import { TableBody, TableCell, TableRow } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import {
  Capitalize,
  LeftBorderCell,
  StyledTable
} from '../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';
import { Bygningsdetaljer } from '../../../../../types/registration/userInput';
import { useBoligInformasjon } from '../hooks/useBoligInformasjon';

interface BoligInformasjonPorps {
  data: Bygningsdetaljer;
}
export const BoligInformasjon: FC<BoligInformasjonPorps> = ({ data }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary' });
  const {
    harOppvarmetKjeller,
    harKjeller,
    konstruksjonsmateriale,
    boenhet,
    totalOppvarmetBRA,
    totalBRA,
    byggear,
    boligtype,
    antallEtasjer
  } = useBoligInformasjon(data);

  return (
    <StyledTable>
      <TableBody>
        {boligtype && (
          <TableRow>
            <TableCell>{t('boliginformasjon.type')}</TableCell>
            <LeftBorderCell>
              <Capitalize>{boligtype}</Capitalize>
            </LeftBorderCell>
          </TableRow>
        )}
        {boenhet && (
          <TableRow>
            <TableCell>{t('boliginformasjon.boenhet')}</TableCell>
            <LeftBorderCell>
              <Capitalize>{boenhet}</Capitalize>
            </LeftBorderCell>
          </TableRow>
        )}
        {byggear && (
          <TableRow>
            <TableCell>{t('boliginformasjon.byggear')}</TableCell>
            <LeftBorderCell>{byggear}</LeftBorderCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell>{t('boliginformasjon.etasjer')}</TableCell>
          <LeftBorderCell>{antallEtasjer}</LeftBorderCell>
        </TableRow>
        {totalBRA && (
          <TableRow>
            <TableCell>{t('boliginformasjon.totaltBRA')}</TableCell>
            <LeftBorderCell>{`${totalBRA} ${t('suffix.m2')}`}</LeftBorderCell>
          </TableRow>
        )}
        {totalOppvarmetBRA && (
          <TableRow>
            <TableCell>{t('boliginformasjon.totaltOppvarmetBRA')}</TableCell>
            <LeftBorderCell>{`${totalOppvarmetBRA} ${t('suffix.m2')}`}</LeftBorderCell>
          </TableRow>
        )}
        {harKjeller && (
          <TableRow>
            <TableCell>{t('boliginformasjon.kjeller')}</TableCell>
            <LeftBorderCell>{harKjeller ? `${t('yes')}` : `${t('no')}`}</LeftBorderCell>
          </TableRow>
        )}
        {harOppvarmetKjeller && (
          <TableRow>
            <TableCell>{t('boliginformasjon.kjellerOppvarmet')}</TableCell>
            <LeftBorderCell>{harOppvarmetKjeller ? `${t('yes')}` : `${t('no')}`}</LeftBorderCell>
          </TableRow>
        )}
        {konstruksjonsmateriale && (
          <TableRow>
            <TableCell>{t('boliginformasjon.materiale')}</TableCell>
            <LeftBorderCell>
              <Capitalize>{konstruksjonsmateriale}</Capitalize>
            </LeftBorderCell>
          </TableRow>
        )}
      </TableBody>
    </StyledTable>
  );
};
